import { iconCredit, iconMarkup } from '../icons.js';
import { mountTooltips, setTooltip } from '../tooltips.js';
import { mountUiScale } from './ui-scale.js';
import { hudDockMarkup, hudOverlayMarkup, mountHudHints } from '../hud/world-hud-markup.js';
import { seal } from '../settings/settings-dialog.js';
import { nimbleAttribution, nimbleBadge, nimbleCreatorPolicy, nimbleFreeUseNotice } from './nimble-credits.js';

export function mountGameShell() {
  document.querySelector<HTMLDivElement>('#app')!.innerHTML = `
    <div id="stage"></div>
    <header class="topbar">
      <span id="world-clock" class="world-clock" tabindex="0" hidden>${iconMarkup('clock')}<span id="world-clock-value"></span></span>
      <button id="mute-toggle" class="menu-button glyph-button" aria-pressed="false"></button>
      <button id="settings-open" class="menu-button glyph-button" aria-haspopup="dialog" aria-controls="settings">${iconMarkup('settings')}</button>
    </header>
    ${hudOverlayMarkup()}
    <div id="gate" class="gate waiting" role="dialog" aria-label="Sealed stone door">
      <canvas id="gate-canvas" class="gate-canvas" aria-hidden="true"></canvas>
      <p id="gate-status" class="gate-status" hidden></p>
    </div>
    <main id="lobby" class="lobby" data-view="menu" inert>
      <p class="lobby-logo" data-for="menu play credits create">NIMBLE<span>Z</span></p>
      <nav id="main-menu" class="stone-panel menu-stack" data-for="menu" aria-label="Main menu">
        <button id="menu-play" class="stone-button">${seal('doorway')}Play</button>
        <button id="menu-create" class="stone-button">${seal('party')}Create new character<span class="menu-lock" hidden>${iconMarkup('padlock')}</span></button>
        <button id="menu-settings" class="stone-button">${seal('settings')}Settings</button>
        <button id="menu-credits" class="stone-button">${seal('scroll')}Credits</button>
        <button id="menu-install" class="stone-button" hidden>${seal('home')}Install</button>
        <button id="menu-close-app" class="stone-button" hidden>${seal('doorway')}Close NimbleZ</button>
      </nav>
      <aside class="nimble-home-notice" data-for="menu" aria-label="Nimble attribution and free-use notice">
      ${nimbleBadge}
      <div>Created with Love, by Z.</div>
        <small>
          ${nimbleAttribution}
          ${nimbleFreeUseNotice}
        </small>
      </aside>
      <section id="credits-panel" class="stone-panel lobby-card" data-for="credits" aria-labelledby="credits-title">
        <h2 id="credits-title" class="panel-title">Credits</h2>
        ${nimbleCreatorPolicy}
        <p class="hint">${iconCredit}</p>
        <button id="credits-back" class="stone-button small" type="button">Back</button>
      </section>
      <section id="creator" class="stone-panel lobby-card creator" data-for="create" aria-labelledby="creator-title"></section>
      <div class="stone-panel lobby-card" data-for="play">
        <h1 id="lobby-title">Sign in</h1>
        <div id="auth-panel">
          <button id="google" class="primary google">Continue with Google</button>
          <div class="divider"><span>or use email</span></div>
          <form id="auth-form">
            <label>Email<input id="email" type="email" autocomplete="email" placeholder="you@example.com" required maxlength="254"></label>
            <label>Password<input id="password" type="password" autocomplete="current-password" minlength="6" required placeholder="At least 6 characters"></label>
            <div class="form-actions"><button class="primary" type="submit">Sign in</button><button id="register" type="button" class="secondary">Create account</button></div>
          </form>
        </div>
        <div id="room-panel" hidden>
          <p id="host-address" class="hint"></p>
          <form id="room-form">
            <label>Room code<input id="room-code" autocomplete="off" required minlength="3" maxlength="24" pattern="[A-Za-z0-9-]{3,24}" value="CROSSING" aria-describedby="room-hint"></label>
            <p id="room-hint" class="hint">Use the same room code as your friend.</p>
            <button id="choose-party" class="primary enter" type="submit">Choose characters</button>
          </form>
        </div>
        <div id="party-panel" hidden>
          <p id="party-room" class="hint"></p>
          <p id="party-hint" class="hint"></p>
          <form id="party-form">
            <div id="party-stage" class="party-stage"></div>
            <fieldset class="party-roster"><div id="party-roster"></div></fieldset>
            <p id="party-count" class="hint"></p>
            <button id="enter-game" class="primary enter" type="submit" disabled>Enter game</button>
            <button id="party-back" class="quiet" type="button">Back to room</button>
          </form>
        </div>
        <p id="lobby-error" class="error"></p>
        <button id="play-back" class="quiet" type="button">‹ Main menu</button>
        <p id="mode" class="mode" hidden></p>
      </div>
    </main>
    ${hudDockMarkup()}
    <div id="toast" hidden></div>
  `;
  const hints: Record<string, [string, string]> = {
    'settings-open': ['Settings', 'Settings'],
    'world-clock': ['In-game time. Advances as you play and jumps when the party rests.', 'In-game time'],
  };
  for (const [id, [hint, label]] of Object.entries(hints)) setTooltip(document.getElementById(id)!, hint, label);
  mountHudHints();
  mountTooltips(document.getElementById('app')!);
  mountUiScale();
}
